export const isLegacyConferenceMessagePayload = (payload: unknown): boolean => {
  if (!payload || typeof payload !== "object") {
    return false;
  }

  return "conference" in payload && !!payload.conference;
};
